<template>
  <div v-if="!$store.getters.getCharts.length">
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="vehicle-stock-retail-analytics">

      <!-- Dashboard loader -->
      <v-layout row>
        <v-flex xs12>
          <base-loader></base-loader>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

  <div v-else>
    <v-container fluid grid-list-lg text-xs-center px-3 py-2 class="vehicle-stock-retail-analytics">

      <!-- Dashboard heading -->
      <v-layout row wrap align-center>
        <v-flex xs12 sm4>
          <last-update-time
            :dashboard-id="id">
          </last-update-time>
        </v-flex>
        <v-flex xs12 sm4>
          <pdf-export
            v-if="pdfExport"
            :dashboard-id="id"
            :dashboard-name="name">
          </pdf-export>
        </v-flex>
        <v-flex xs12 sm4>
          <v-btn class="ma-0" @click="showFilters = true" ef-feature-id="filters-btn">
            <v-icon class="mr-1">filter_list</v-icon> {{ translation('filters.btn-filter') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>

      <!-- Dashboard filters -->
      <v-layout row v-show="showFilters">
        <stock-history-report-filter
          :dashboard-id="id"
          @close-filters="showFilters = false"
          @apply-filters="fetchDashboardData(); showFilters = false"
          @clear-filters="fetchDashboardData">
        </stock-history-report-filter>
      </v-layout>

      <!-- Dashboard scorecards -->
      <v-layout row wrap v-if="hideCharts.indexOf('StockHistoryReport_stockByYearMonthCondition') === -1">
        <v-flex xs12>
          <chart-line
            chart-key="StockHistoryReport_stockByYearMonthCondition"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="hideCharts.indexOf('StockHistoryReport_epByYearMonthCondition') === -1">
        <v-flex xs12>
          <chart-line
            chart-key="StockHistoryReport_epByYearMonthCondition"
            @open-dialog="openDialog($event)">
          </chart-line>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="hideCharts.indexOf('StockHistoryReport_DaysOnStockByYearMonthCondition') === -1">
        <v-flex xs12>
          <chart-clustered-column
            chart-key="StockHistoryReport_DaysOnStockByYearMonthCondition"
            @open-dialog="openDialog($event)">
          </chart-clustered-column>
        </v-flex>
      </v-layout>

      <!-- chart dialog window -->
      <v-dialog max-width v-model="dialog" @input="closeDialog()">
        <v-card>
          <v-card-title class="subheading">
            {{ dialogTitle }}
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click.stop="closeDialog()">
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="chart-wrapper">
              <component
                :is="dialogComponent"
                v-bind="dialogProperties"
                :from-dialog="true">
              </component>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { eventBus } from '@/eventBus'
import { mapGetters, mapMutations } from 'vuex'
import * as am4core from '@amcharts/amcharts4/core'
// import am4themesAnimated from '@amcharts/amcharts4/themes/animated'
// import am4themesMaterial from '@amcharts/amcharts4/themes/material'
// import { am4themesEfdThemeAchr } from '@/themes'
// import moment from 'moment'

import BaseLoader from '@/components/loaders/BaseLoader'
import LastUpdateTime from '@/components/LastUpdateTime'
// import Filters from './DashboardVehicleStockRetailFiltersGen'
import StockHistoryReportFilter from '@/components/dashboards/vp/DashboardStockHistoryReportFiltersGenSidebar'
import WidgetKpi from '@/components/charts/WidgetKpi'
import ChartClusteredColumn from '@/components/charts/ChartClusteredColumn'
import ChartClusteredColumnRender from '@/components/charts/ChartClusteredColumnRender'
import ChartLine from '@/components/charts/ChartLine'
import ChartLineRender from '@/components/charts/ChartLineRender'

// am4core.useTheme(am4themesAnimated)
// am4core.useTheme(am4themesMaterial)
// am4core.useTheme(am4themesEfdThemeAchr)
am4core.options.queue = true
export default {
  name: 'VehicleStockRetail',
  components: {
    BaseLoader,
    LastUpdateTime,
    StockHistoryReportFilter,
    WidgetKpi,
    ChartClusteredColumn,
    ChartClusteredColumnRender,
    ChartLine,
    ChartLineRender
    // PdfExport
  },
  data () {
    return {
      id: 'StockHistoryReport',
      name: 'StockHistoryReport',
      charts: [
        {
          key: 'StockHistoryReport_stockByYearMonthCondition',
          title: 'chart.title.StockHistoryReport_stockByYearMonthCondition',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            multiline: true,
            // displayLength: 12, // 12 for moths per year
            fillOpacity: 0, // fill of area below line
            tensionX: 1, // line smoothness
            strokeWidth: 2, // line thickness
            colorSteps: 2, // values color difference
            legend: true,
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false
          }
        },
        {
          key: 'StockHistoryReport_epByYearMonthCondition',
          title: 'chart.title.StockHistoryReport_epByYearMonthCondition',
          loaded: false,
          export: true,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            multiline: true,
            // displayLength: 12, // 12 for moths per year
            fillOpacity: 0, // fill of area below line
            tensionX: 1, // line smoothness
            strokeWidth: 2, // line thickness
            colorSteps: 2, // values color difference
            legend: true,
            labelRotation: 270,
            maxLabelWidth: 200, // px
            labelHorizontalCenter: 'right'
          },
          data: {},
          pagination: {
            descending: false
          }
        },
        {
          key: 'StockHistoryReport_DaysOnStockByYearMonthCondition',
          title: 'chart.title.StockHistoryReport_DaysOnStockByYearMonthCondition',
          loaded: false,
          export: true,
          exportDetailed: false,
          exportTo: ['xlsx', 'csv'],
          chartSettings: {
            keyModified: true,
            sortDate: true
          },
          data: {},
          pagination: {
            totalItems: 0,
            descending: false,
            sortBy: null,
            page: 1,
            rowsPerPage: 117
          }
        }
      ],
      pdfExport: false,
      hideCharts: [],
      showFilters: false,
      // dialog data
      dialog: false,
      dialogComponent: '',
      dialogTitle: '',
      dialogProperties: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedFiltersGen', 'getCharts', 'getChartByKey', 'translation', 'currency'
    ]),
    translatedChartTitles: {
      get () {
        return this.charts.map(chart => {
          chart.valueType && chart.valueType === 'money'
            ? chart.title = this.translation(chart.title, { currency: this.currency })
            : chart.title = this.translation(chart.title)
          return chart
        })
      }
    }
  },
  created () {
    this.setCharts(this.translatedChartTitles)
  },
  mounted () {
    this.fetchDashboardData()
  },
  beforeDestroy () {
    // empty charts from store
    this.setCharts([])
  },
  methods: {
    ...mapMutations({
      setCharts: 'SET_CHARTS'
    }),
    fetchDashboardData () {
      // emit event for fetching data from components
      eventBus.$emit('update-dashboard')
    },
    openDialog (dialogData) {
      this.$store.dispatch('fetchChartData', {
        key: dialogData.chartObj.key,
        settings: dialogData.chartObj.settings,
        filters: this.$store.getters.isGenericGen ? this.$store.getters.selectedFiltersGen : this.$store.getters.selectedFilters,
        pagination: { ...dialogData.chartObj.pagination, rowsPerPage: dialogData.chartObj.data.metadata.total }
      }).then(() => {
        this.$log.info('dialogData', dialogData)
        // assign received data from clicked component to Dialog component
        this.dialogComponent = dialogData.chartType
        this.dialogProperties = {}
        this.dialogProperties = { chartKey: dialogData.chartObj.key }
        this.dialogTitle = this.getChartByKey(dialogData.chartObj.key).title
        this.dialog = true
      })
    },
    closeDialog () {
      // clear data for component
      this.dialogComponent = ''
      this.dialogProperties = {}
      this.dialogTitle = ''
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
  .loader-wrapper {
    position: relative;
    height: 50px;
  }
  .vehicle-stock-retail-analytics {
  }
  .lib-link a{
    text-decoration: none;
  }
  @media only screen and (max-device-width: 700px) {
    .vehicle-stock-retail-analytics {
    }
  }
</style>
